<template>
  <div :class="'fm-flex ' + customClass" :style="viewStyle">
    <div :class="leftFlex ? 'fm-childflex' : ''" :style="leftStyle">
      <slot name="left"></slot>
    </div>
    <div :class="rightFlex ? 'fm-childflex' : ''" :style="rightStyle">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customClass: {
      type: String,
      default: "",
    },
    customStyle: {
      type: [String, Object],
      default: "",
    },
    leftFlex: {
      type: Boolean,
      default: true,
    },
    rightFlex: {
      type: Boolean,
      default: true,
    },
    /**
     * 效果说明：
     * 		between	两边排列，超出左侧隐藏
     * 		left			从左往右排列，超出左侧隐藏
     * 		right		从左往右排列，超出右侧隐藏
     */
    type: {
      type: String,
      default: "between",
    },
  },
  computed: {
    viewStyle() {
      if (typeof this.customStyle == "undefined") {
        return "width:100%";
      } else if (typeof this.customStyle == "string") {
        return "width:100%;" + this.customStyle;
      } else {
        return {
          with: "100%",
          ...this.customStyle,
        };
      }
    },
    leftStyle() {
      if (this.type == "left") {
        return {
          overflow: "hidden",
        };
      } else if (this.type == "right") {
        return {
          "text-wrap": "nowrap",
          "white-space": "nowrap",
        };
      } else {
        return {
          flex: 1,
          overflow: "hidden",
          width: 0,
        };
      }
    },
    rightStyle() {
      if (this.type == "left") {
        return {
          "margin-left": 0,
          "text-wrap": "nowrap",
          "white-space": "nowrap",
        };
      } else if (this.type == "right") {
        return {
          "margin-left": 0,
        };
      } else {
        return {
          "margin-left": "auto",
          "text-wrap": "nowrap",
          "white-space": "nowrap",
        };
      }
    },
  },
  data() {
    return {};
  },
};
</script>

<style >
</style>


// WEBPACK FOOTER //
// src/components/fm/FmJustifyView.vue